import { fromJS } from 'immutable'

export const corState = fromJS({})

const initialState = fromJS({
  hasFetched: false,
  changeSectionList: {},
})

export default function cor(state = initialState, action) {
  switch (action.type) {
    case 'COR_GET_SUCC':
      return state.set('hasFetched', true)

    case 'CHSEC_SUCC':
      return state.setIn(
        ['changeSectionList', action.meta.offeringSubjectID],
        fromJS(action.payload || []),
      )

    case 'CHANGE_SEC_SUCC':
      return state.set('changeSectionList', fromJS({}))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/COR/reducer.js